export const CUSTOM_HEADER = {
    ENABLE_LOADING: 'enable-loading',
    DISABLE_ERROR_HANDLER: 'disable-error-handler',
    CONTINUE_ON_ERROR: 'continue-on-error'
}